import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { AccountCircleOutlined, ExitToAppOutlined, PersonOutline } from '@material-ui/icons';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import { Billing } from 'icons';
import DropdownTab from './DropdownTab';
import UserName from './UserName';
import Points from 'assets/rewards/points.png';

import { setFilters as actionSetFilters } from 'store/actions/filtersActions';
import { signOut } from 'services/helpers/signOut';

const useStyles = makeStyles((theme) => ({
  tab: {
    '&:not(:last-child)': {
      marginRight: theme.spacing(4),
    },
    [theme.breakpoints.down('xl')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  badge: {
    width: '24px',
    height: '24px',
    marginRight: theme.spacing(1),
  },
}));

// Reset sorting before open the contacts page
const contactsDefaultSearchParams = new URLSearchParams({
  page: '1',
  perPage: '10',
  sort: 'fullName',
  order: 'ASC',
  filter: '',
}).toString();

const UserMenu = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const handleLogout = async () => {
    await signOut();
  };

  // Reset sorting before open the contacts page
  const handleResetContactsSearchFilter = () => {
    dispatch(actionSetFilters({ resource: 'contacts', filters: { q: '' } }));
  };

  return (
    <DropdownTab className={classes.tab} label={<UserName />}>
      <MenuItem component={NavLink} to="/rewards">
        <img className={classes.badge} src={Points} alt="" />
        Rollo rewards
      </MenuItem>
      <MenuItem component={NavLink} to="/profile">
        <AccountCircleOutlined className={classes.icon} /> Profile
      </MenuItem>
      <MenuItem component={NavLink} to="/billing">
        <Billing className={classes.icon} /> Billing
      </MenuItem>
      <MenuItem component={NavLink} to="/shippingPresets">
        <SettingsOutlinedIcon className={classes.icon} /> Settings
      </MenuItem>
      <MenuItem
        onClick={handleResetContactsSearchFilter}
        component={Link}
        to={{
          pathname: '/contacts',
          search: contactsDefaultSearchParams,
        }}>
        <PersonOutline className={classes.icon} /> Contacts
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <ExitToAppOutlined className={classes.icon} /> Logout
      </MenuItem>
    </DropdownTab>
  );
};

export default UserMenu;
